import { render, staticRenderFns } from "./AdminBrandPurchase.vue?vue&type=template&id=5b5eb52c&scoped=true"
import script from "./AdminBrandPurchase.vue?vue&type=script&lang=js"
export * from "./AdminBrandPurchase.vue?vue&type=script&lang=js"
import style0 from "./AdminBrandPurchase.vue?vue&type=style&index=0&id=5b5eb52c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5eb52c",
  null
  
)

export default component.exports